module.exports = __webpack_public_path__ + "static/media/project.f3fed069.svg";